import React, { Component } from "react";
import styled from "@emotion/styled/macro";
class TooltipT1 extends Component {
  render() {
    const { text, children } = this.props;

    return (
      <TooltipContainer>
        <TooltipTrigger>{children[0]}</TooltipTrigger>
        <Tooltip>{children[1]}</Tooltip>
      </TooltipContainer>
    );
  }
}

export default TooltipT1;
const Tooltip = styled("div")`
  display: none;
  position: absolute;
  top: 120%;
  left: 20%;
  z-index: 1;
`;

const TooltipContainer = styled("div")`
  &:hover {
    position: relative;
  }
  &:hover ${Tooltip} {
    display: block;
  }
`;

const TooltipTrigger = styled("div")`
  cursor: pointer;
`;
